export default __webpack_public_path__ + "static/media/android-launchericon-144-144.95256c4b.png";